import { Search, Droplets, Waves, SprayCan } from "lucide-react";

const steps = [
  {
    icon: Search,
    step: "01",
    title: "Inspection",
    desc: "Thorough inspection of your tank to assess the cleaning requirements and condition.",
  },
  {
    icon: Droplets,
    step: "02",
    title: "Dewatering",
    desc: "Safe draining of existing water and removal of accumulated sediment and sludge.",
  },
  {
    icon: Waves,
    step: "03",
    title: "High Pressure Jet Cleaning",
    desc: "Powerful jet washing of walls, floor, and corners to remove all buildup and biofilm.",
  },
  {
    icon: SprayCan,
    step: "04",
    title: "Disinfection",
    desc: "Anti-bacterial treatment and UV sanitization ensuring 100% germ-free water storage.",
  },
];

export default function ProcessSection() {
  return (
    <section id="process" data-testid="process-section" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <p className="text-sky font-medium text-sm uppercase tracking-[0.2em] mb-3">
            Our Process
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-navy">
            How It Works
          </h2>
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative">
          <div className="hidden md:block absolute top-12 left-[12.5%] right-[12.5%] h-0.5 bg-gradient-to-r from-sky/20 via-sky/40 to-sky/20" />

          {steps.map((s, i) => (
            <div key={s.title} data-testid={`process-step-${i}`} className="relative text-center">
              <div className="relative z-10 w-24 h-24 rounded-2xl bg-surface border border-slate-200 flex flex-col items-center justify-center mx-auto mb-6 hover:shadow-lg hover:border-sky/50 transition-all duration-300">
                <s.icon className="w-8 h-8 text-sky" />
              </div>
              <span className="inline-block text-xs font-bold text-sky uppercase tracking-[0.2em] mb-2">
                Step {s.step}
              </span>
              <h3 className="font-heading font-semibold text-lg text-navy mb-2">
                {s.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
